<template>
  <div :class="`pass-type ${passType.class || ''}`">
    <h2 class="pass-type__title">{{ passType.name }}</h2>
    <div class="pass-type__inner">
      <div class="pass-type__price">
        <h3 class="pass-type__price__amount" v-html="amountHtml" />
        <h4 class="pass-type__price__subhead">
          {{ passType.priceSubheading }}
        </h4>
      </div>
      <div class="pass-type__description" v-html="passType.description"></div>
      <a href="#" @click.prevent="selectPass" class="button">Sign Up<span class="sr-only">for {{passType.name}}</span></a>
    </div>
    <div class="pass-type__terms" v-html="passType.terms"></div>
  </div>
</template>
<script>
export default {
  props: {
    pass: Number,
  },
  computed: {
    passType() {
      return this.$store.state.passTypes.find(type => type.id === this.pass);
    },
    systemId() {
      return this.$store.state.systemId;
    },
    amountHtml() {
      return this.passType.displayPrice || `$${this.passType.price}`;
    },
  },
  methods: {
    selectPass() {
      this.$store.dispatch('updatePass', this.passType.id);
      this.$router.push({
        name: this.$store.getters.nextStep(this.$route.name),
      });
    },
  },
};
</script>
